import { API } from 'aws-amplify';

const API_NAME_V2 = 'admin-api-v2';

export const getPendingSignups = async () => {
  return API.get(API_NAME_V2, '/pilot-signups', {});
};

export const getLeadSignups = async (leadId) => {
  return API.get(API_NAME_V2, `/sales-lead/${encodeURIComponent(leadId)}/signups`, {});
};

export const approveSignup = async (token) => {
  return API.post(API_NAME_V2, `/pilot-signups/${encodeURIComponent(token)}/approve`, {});
};

export const rejectSignup = async (token) => {
  return API.post(API_NAME_V2, `/pilot-signups/${encodeURIComponent(token)}/reject`, {});
};
